import React, { memo, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getexploreListing, getExplorePhysicalArt } from "store/actions";
import CategoryCard2 from "Pages/category/CategoryCard2";
import { Oval } from "react-loader-spinner";
import CategoryCardPhysical from "Pages/category/CategoryCardPhysical";
export default memo(function DigitalArtcollection(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { exploreListing } = useSelector((state) => state?.SellItems);
  const { physicalListing } = useSelector(
    (state) => state?.PhysicalSellItems || {}
  );

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);
  useEffect(() => {
    dispatch(getexploreListing({}));
    dispatch(getExplorePhysicalArt());
  }, []);
  console.log(
    "Physical Artwork==================================================:",
    physicalListing
  );

  return (
    <section className="DigitalArtcollection-main position-relative">
      {loading && (
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}
      <Container>
        <Row>
          <Col lg={12}>
            <div className="d-flex align-items-baseline justify-content-between">
              <div className="DigitalArtcollection-head">
                <h2 className="mb-3">Physical Art </h2>
                <p>A brief sample of available Physical Artworks</p>
              </div>
              <Link
                className="viewText d-flex align-items-center gap-2"
                to="/art-genres"
                state={{ isPhysical: "physical" }}
              >
                View all{" "}
                <svg
                  width="30"
                  height="16"
                  viewBox="0 0 30 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.01214 7.00007C0.459892 6.99337 0.00677631 7.43562 7.36713e-05 7.98786C-0.00662897 8.54011 0.43562 8.99322 0.987864 8.99993L1.01214 7.00007ZM29.6985 9.05548C30.0937 8.66972 30.1014 8.0366 29.7156 7.64137L23.4294 1.20064C23.0436 0.805404 22.4105 0.79772 22.0153 1.18348C21.62 1.56923 21.6123 2.20235 21.9981 2.59759L27.5859 8.32268L21.8608 13.9105C21.4656 14.2962 21.4579 14.9293 21.8436 15.3246C22.2294 15.7198 22.8625 15.7275 23.2577 15.3417L29.6985 9.05548ZM0.987864 8.99993L28.9879 9.33977L29.0121 7.33991L1.01214 7.00007L0.987864 8.99993Z"
                    fill="black"
                  />
                </svg>
              </Link>
            </div>
          </Col>
          <Col lg={12}>
            <Row>
              {/* show the physical arts collection */}
              {physicalListing && physicalListing?.length > 0 ? (
                <>
                  {physicalListing &&
                    physicalListing?.map((phData, idx) => {
                      return (
                        <Col className="mb-4" lg={3} key={idx}>
                          <CategoryCardPhysical
                            data={{ ...phData, isPhysicalNew: true }}
                          />
                        </Col>
                      );
                    })}
                </>
              ) : (
                <>
                  <div className="text-center d-grid justify-content-center dataNotFound py-5">
                    <img
                      src={"../../images/svg/mpdatanft.svg"}
                      className="mb-4"
                      alt="Create collection"
                    />
                    <h3>No Physical Artworks Available</h3>
                  </div>
                </>
              )}
            </Row>
          </Col>

          <Col className="mt-5" lg={12}>
            <div className="d-flex align-items-baseline justify-content-between">
              <div className="DigitalArtcollection-head">
                <h2 className="mb-3">Digital Artwork </h2>
                <p>A brief sample of available Digital Artworks</p>
              </div>
            </div>
          </Col>
          <Col lg={12}>
            <Row>
              {exploreListing?.length > 0 ? (
                <>
                  {exploreListing?.map((nftData, idx) => {
                    return (
                      <Col className="mb-4" lg={3} key={idx}>
                        <CategoryCard2 data={nftData} />
                      </Col>
                    );
                  })}
                </>
              ) : (
                <>
                  <div className="text-center d-grid justify-content-center dataNotFound py-5">
                    <img
                      src={"../../images/svg/mpdatanft.svg"}
                      className="mb-4"
                      alt="Create collection"
                    />
                    <h3>No Digital Artworks Available</h3>
                  </div>
                </>
              )}
            </Row>
          </Col>
          <div className="text-center show-wrap">
            <Link className="link-text" to="/art-genres">
              <button className="LearnMoreBtn">
                {" "}
                Explore All Artworks{" "}
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3312 7.08301L18.3228 7.08301L18.3144 7.08357L18.1788 7.09271L18.1704 7.09327L18.162 7.09441C17.5516 7.17721 17.0812 7.69994 17.0812 8.33301V8.34147L17.0818 8.34992L17.091 8.48561L17.0916 8.49397L17.0927 8.50227C17.1754 9.11269 17.6982 9.58301 18.3312 9.58301H25.3132L16.3337 18.5638L12.5499 14.7801L12.5434 14.7736L12.5365 14.7676L12.4243 14.6708L12.4173 14.6648L12.4099 14.6593C11.9204 14.2962 11.2261 14.3363 10.7822 14.7801L10.7821 14.7801L2.78213 22.7801L2.77561 22.7866L2.76959 22.7936L2.67277 22.9059L2.66678 22.9128L2.66131 22.9202C2.29809 23.4097 2.3382 24.1039 2.78212 24.5479L2.78213 24.5479C3.27028 25.0361 4.06175 25.0361 4.5499 24.5479L11.666 17.4318L15.4499 21.2155L15.4564 21.222L15.4633 21.228L15.5754 21.3248L15.5824 21.3308L15.5898 21.3363C16.0794 21.6996 16.7738 21.6593 17.2177 21.2156L17.2177 21.2155L27.0827 11.3486L27.0832 18.3382V18.3467L27.0838 18.3551L27.093 18.4908L27.0936 18.4992L27.0947 18.5076C27.1775 19.1178 27.7003 19.5882 28.3332 19.5882C29.0237 19.5882 29.5832 19.0285 29.5832 18.3382L29.5827 8.29499V8.28256L29.5814 8.27019L29.5689 8.14459L29.5675 8.1309L29.5647 8.11744L29.5466 8.0321L29.5445 8.02228L29.5416 8.01266L29.5161 7.92722L29.512 7.91342L29.5063 7.90018L29.4547 7.77975L29.448 7.76402L29.4392 7.74936L29.3669 7.6292L29.3595 7.61679L29.3506 7.60533L29.2926 7.53016L29.2858 7.52136L29.2783 7.5132L29.224 7.45448L29.2242 7.45434L29.2171 7.44726C29.1088 7.33913 28.9843 7.25364 28.8495 7.19432L28.8495 7.1943L28.8463 7.19295L28.766 7.15889L28.7512 7.15262L28.7357 7.1483L28.604 7.11149L28.5877 7.10695L28.571 7.10463L28.4373 7.08607L28.4202 7.0837L28.403 7.0837L18.3312 7.08301Z"
                    fill="white"
                    stroke="white"
                    stroke-width="0.5"
                  />
                </svg>
              </button>
            </Link>
          </div>
        </Row>
        {/* <Row>
          <Col lg={12} >
            <div className="d-flex align-items-baseline justify-content-between mb-2">
              <div className="DigitalArtcollection-head">
                <h2 className="mb-4 mt-3">Printable NFT’s </h2>
              </div>
            </div>
          </Col>
          <Col lg={12}>
            <Row>
              {(exploreListing?.length > 0) ? (
                <>
                  {exploreListing?.map((nftData, idx) => {
                    return (

                      <Col className="mb-4" lg={3} key={idx}>
                        <CategoryCard2 data={nftData} />
                      </Col>
                    )
                  })}
                </>
              ) : (<>
                <div className="text-center d-grid justify-content-center dataNotFound py-5">
                  <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                  <h3>No NFTs Available</h3>
                </div>
              </>)}

            </Row>
          </Col>
         
        </Row> */}
      </Container>
    </section>
  );
});
